import React from 'react'

import LayoutCentered from '@components/LayoutCentered/LayoutCentered'

@LayoutCentered
class RegistrationComplete extends React.Component {
	render() {
		return (
			<div className="RegistrationComplete">
				<h1>Registration Successful</h1>
				<h2>Thank you for registering. We will contact you to arrange an interview shortly.</h2>
			</div>
		)
	}
}

export default RegistrationComplete


// WEBPACK FOOTER //
// ./src/scenes/Register/RegistrationComplete.jsx